import React, { Component } from "react";
// import $ from "jquery";

import { detailsPageBaseUrl, shareDefaultText } from "../../utils/url";
import { appShareTextString, iOS, onShareClick, onSocialShareCT } from "../../utils/helper";
import { imageStore } from "../../config/store";
import Loader from "../loader/loader";

class NativeShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: shareDefaultText,
      baseurl: "",
      detailurl: "",
      image: "",
      sharePopup: true,
      shareIconShow: true,
      appShare: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    let { sharedata } = this.props;
    // console.log("sharedata ", sharedata);
    if (sharedata.image) {
      this.setState({ image: sharedata.image });
    }
    if (sharedata.text) {
      let text = sharedata.text.split("<br/>").join("");
      this.setState({ text, textOrg: sharedata.text });
    }
    let detailurl = detailsPageBaseUrl;
    if (sharedata.postid) {
      detailurl += sharedata.postid;
      this.setState({ postid: sharedata.postid });
    }
    if (sharedata.sharepopup && sharedata.sharepopup === "false") {
      this.setState({ sharePopup: false });
    }
    if (sharedata.shareicon && sharedata.shareicon === "false") {
      this.setState({ shareIconShow: false });
    }
    let org_url = "test";
    if (localStorage.getItem("org_url")) {
      org_url = localStorage.getItem("org_url");
    }
    if (org_url.indexOf("appversionandroid") > -1) {
      this.setState({ appShare: true });
    }
    this.setState({ detailurl, baseurl: detailurl });
  }

  handleShare = () => {
    // console.log(this.state.text, this.state.detailurl, this.state.image)
    var org_url = "test";
    if (localStorage.getItem("org_url")) {
      org_url = localStorage.getItem("org_url");
    }
    try {
      if (org_url.indexOf("appversionandroid") > -1) {

        var sharelink = `appshare://text=${appShareTextString(this.state.text)} ${this.state.detailurl} &imageurl=${this.state.image}`;
        // alert(sharelink);
        onShareClick("appnative", this.state.postid);
        onSocialShareCT({
          type: "appnative",
          shareurl: this.state.detailurl,
          text: this.state.text,
          image: this.state.image
        });
        window.location.href = sharelink;
      } else {
        this.handleNativeShare();
      }
    } catch (e) {
      this.handleNativeShare();
    }
  };

  handleNativeShare = async () => {
    let ref = this;
    // if (ref.state.image != "") {
    //   if (ref.state.image.indexOf("s3.ap-south-1.amazonaws.com/js-sdk-bucket") !== -1) {
    //     ref.state.image = ref.state.image.replace(
    //       "s3.ap-south-1.amazonaws.com/js-sdk-bucket",
    //       "campaign-images.narendramodi.in"
    //     );
    //   }
    // }
    let title = this.state.text;
    let text = this.state.text;
    let url = this.state.baseurl;

    let data = {
      // files: [file],
      title,
      text,
      url,
    };
    // if (navigator && navigator.canShare && navigator.canShare(data)) {
    if (navigator && navigator.canShare && navigator.canShare(data) && !iOS()) {
      if (ref.state.image) {
        ref.setState({ isLoading: true });
        if (document.getElementById("preloader_mantra")) {
          document.getElementById("preloader_mantra").style.display = "block";
        }
        const mediafile = ref.state.image;
        const fileSpliteString = mediafile.split(".");
        let extension = fileSpliteString[fileSpliteString.length - 1];
        const filename = `campaign_img.${extension}`;
        const response = await fetch(mediafile);

        const blob = await response.blob();
        const file = new File([blob], filename, {
          type: blob.type,
        });
        if (file) {
          data["files"] = [file];
        } else {
          alert("file not found");
        }
        console.log("Successful share ", navigator.canShare(data));

        navigator
          .share(data)
          .then(() => {
            console.log("Successfully native shared data");
            onShareClick("webnative", this.state.postid);
            onSocialShareCT({
              type: "webnative",
              shareurl: this.state.detailurl,
              text: this.state.text,
              image: this.state.image
            });
          })
          .catch((error) => {
            console.log("Error native sharing", error);
            if (ref.state.sharePopup) {
              ref.showSharePopup();
            }
          });
        ref.setState({ isLoading: false });
        if (document.getElementById("preloader_mantra")) {
          document.getElementById("preloader_mantra").style.display = "none";
        }
      }
    } else {
      let sharemsg =
        "Native share only work for Chrome for Android v>=75 / Samsung Internet v>=11.0";
      console.log(sharemsg);
      if (ref.state.sharePopup) {
        this.showSharePopup();
      }
    }
  };

  showSharePopup = () => {
    this.setState({ isLoading: false });
    if (document.getElementById("preloader_mantra")) {
      document.getElementById("preloader_mantra").style.display = "none";
    }
    imageStore.dispatch({
      type: "SET_IMG",
      data: {
        text: this.state.textOrg,
        detailurl: this.state.detailurl,
        image: this.state.image,
        open: true
      },
    });
    // old popup show by
    // $(".popup_fixed").show();
  };

  render() {
    let share_icon = this.props.share_icon
      ? this.props.share_icon
      : "/images/shr.svg";
    let btnClassName = this.props.btnClassName
      ? this.props.btnClassName
      : "share_btn_ ml5";
    let imgClassName = this.props.imgClassName
      ? this.props.imgClassName
      : "share_ico";
    if (this.state.isLoading) {
      return <Loader />;
    }
    // if (((navigator && navigator.canShare) || this.state.appShare) && !iOS()) {
    if (this.props.children) {
      return <div onClick={this.handleShare}>{this.props.children}</div>;
    } else {
      return (
        <button
          className={btnClassName}
          id="buttonShare"
          onClick={this.handleShare}
        >
          Share
          <img src={share_icon} className={imgClassName} />
        </button>
      );
    }
    // }
    return "";
  }
}

export default NativeShare;

{
  /* <NativeShare 
  sharedata={{text:"", baseurl: "", image: "", postid:"" }} 
  share_icon="" 
  className="" 
/> */
  /* <NativeShare
    sharedata={{
      image: item.canvasImage,
      text: "sharetext",
      postid: this.state.postId,
      sharepopup: "false",
    }}
  >
    <a>
      <div className="nativ_shr">
        <img src="/images/share.png" className="" />
      </div>
      <figcaption>Share with</figcaption>
    </a>
  </NativeShare>*/
}
